<div class="sail-loader">
  <div class="boat-container">
    <div class="boat">
      <img src="assets/common_icons/sail_loader_boat.svg" width="120" height="120" />
    </div>
  </div>

  <p class="text">Time for Sailing...</p>
</div>